import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Picker, SystemText } from '@salesperformanceint/e4shared';
import { load, add, update, remove } from 'actions/admin';
import { setShowSuccess } from 'actions/ui';
import SimpleAdmin, { DefaultOptions } from 'components/simpleAdmin';
import BlobImage from 'components/blobImage';

export const AdminDepartments = ({ ...props }) => {
    const dispatch = useDispatch();

    const [pickerItem, setPickerItem] = useState();
    const [showPicker, setShowPicker] = useState();

    const data = useSelector(state => state.admin.departments);
    const activeUsers = useSelector(state => state.admin.profiles?.filter(p => p.active));

    const onLoad = () => {
        dispatch(load('department'));
    };

    const loadActiveUsers = () => {
        dispatch(load('profile'));
    };

    const onAdd = (entity, callback) => {
        dispatch(add('department', entity, null, callback));
    };

    const onUpdate = (entity, callback) => {
        dispatch(update('department', entity, null, callback));
    };

    const onRemove = (ids, callback) => {
        if (!Array.isArray(ids)) ids = [ids];
        ids.forEach((id, idx) => {
            dispatch(remove('department', id, () => idx + 1 === ids.length && callback()));
        });
    };

    useEffect(() => {
        onLoad();
        loadActiveUsers();
    }, []);

    const options = {
        ...DefaultOptions(),
        label: SystemText('Admin/Departments/Label/Options'),
    };

    const fields = [
        {
            label: SystemText('Admin/Departments/Fields/Label/Name'),
            type: 'text',
            dataProperty: 'name',
            mandatory: true,
            maxLength: 50,
            generalErrors: true,
            uniqueErrors: true,
            help: SystemText('Admin/Departments/Fields/Help/Name'),
        },
        {
            label: SystemText('Admin/Departments/Fields/Label/Parent'),
            help: SystemText('Admin/Departments/Fields/Help/Parent'),
            type: 'select',
            dataProperty: 'parent_Id',
            isTree: true,
            data: [...data],
            dataBlock: 'id',
            allowMultiple: false,
            placeholder: SystemText('Admin/Departments/Fields/Placeholder/Parent'),
        },
        {
            label: SystemText('Admin/Departments/Fields/Label/Benchmarks'),
            type: 'toggle',
            mandatory: false,
            dataProperty: 'show_Benchmarks',
            help: SystemText('Admin/Departments/Fields/Help/Benchmarks'),
            inTitleBar: true,
        },
    ];

    const tableColumns = [
        { label: SystemText('Admin/Departments/Table/Columns/Name'), dataProperty: 'name' },
        { label: SystemText('Admin/Departments/Table/Columns/Parent'), dataProperty: 'parent' },
        {
            label: SystemText('Admin/Departments/Table/Columns/Users'),
            dataProperty: 'staff_Ids',
            showCount: true,
            onClick: item => {
                setPickerItem(item);
                setShowPicker(true);
            },
        },
    ];

    return (
        <div data-testid="admin-departments-wrapper-testid">
            <SimpleAdmin
                {...props}
                data={data}
                add={onAdd}
                load={onLoad}
                update={onUpdate}
                remove={onRemove}
                fields={fields}
                options={options}
                columns={tableColumns}
                defaultValues={{ show_Benchmarks: true }}
            />
            <Picker
                title={SystemText('Admin/Departments/Pickers/Title/Users', pickerItem?.name)}
                help={SystemText('Admin/Departments/Pickers/Help/Users')}
                entity={SystemText('Admin/Departments/Pickers/Entity/Users')}
                data={activeUsers}
                nameProperty="full_Name"
                filterOption="staff"
                value={pickerItem?.staff_Ids}
                show={showPicker}
                onSave={ids => {
                    onUpdate({ ...pickerItem, update_Staff_Ids: ids }, () => {
                        dispatch(setShowSuccess(SystemText('Admin/Departments/ShowSuccess/SaveUsers')));
                        setShowPicker(false);
                        onLoad();
                    });
                }}
                onClose={() => {
                    setShowPicker(false);
                    setPickerItem(null);
                    setShowSuccess(null);
                }}
                itemPrefix={p => (
                    <div className="image-holder mr10">
                        <BlobImage folder="avatar" src={p.avatar} initials={p.initials} />
                    </div>
                )}
            />
        </div>
    );
};

export default AdminDepartments;
